<template>
  <a-modal
    class="err-batch"
    :visible="visible"
    :width="1140"
    :keyboard="false"
    :mask-closable="false"
    @cancel="handleCancel"
  >
    <template #title>
      <div class="batch-title">
        <span>指定批次</span>
        以下货品库存不足，请修改出库数量后再次提交订单
      </div>
    </template>
    <template #footer>
      <div class="flex justify-between">
        <div>
          <a-button type="primary" @click="handleAvailable">按可用库存出库</a-button>
        </div>
        <div>
          <a-button @click="handleCancel">取消</a-button>
          <a-button type="primary" @click="handleOk">确定</a-button>
        </div>
      </div>
    </template>
    <a-alert message="货品库存不足，下单失败，请核对货品库存数量" banner />
    <a-table
      :columns="tableColumns"
      :data-source="errList"
      :pagination="false"
      :row-key="(record, index) => index"
      :scroll="{y: '40vh'}"
      class="goods-table table-sigle"
    >
      <span slot="numberTitle"><span class="titleStyle">*</span>数量</span>
      <span slot="companyTitle"><span class="titleStyle">*</span>出库单位</span>
      <template slot="action" slot-scope="text, rowData, index">
        <span class="deleteBtn" @click="specifyBatch(index, rowData)">指定批次</span>
        <span class="deleteBtn deleteText" @click="onGoodsDelete(index)">删除</span>
      </template>
      <template slot="stationFullAddress" slot-scope="text">
          <a-tooltip placement="top">
              <template slot="title">{{text}}</template>
              <div class="lengthHidden">{{text}} </div>
          </a-tooltip>
      </template>
      <!-- 数量 -->
      <template slot="number" slot-scope="text, record, index">
        <div>
          <a-form-model-item>
            <InputNumber
              v-model.trim="errList[index]['number']"
              @change="(value) => { changePrice(value, index) }"
            />
          </a-form-model-item>
        </div>
      </template>
      <template slot="skuUnit" slot-scope="text, record, index">
        <div>
          <a-form-model-item>
            <a-select
              v-model="errList[index]['skuUnit']"
              :default-value="text"
              style="width: 80px"
            >
              <a-select-option
                v-for="temp in record.unit"
                :key="temp.value"
                :value="temp.value"
              >{{temp.value}}</a-select-option>
            </a-select>
          </a-form-model-item>
        </div>
      </template>
    </a-table>
    <SpecifyBatch ref="specifyBatch" @chooseBatch="chooseBatch" />
  </a-modal>
</template>

<script>
import InputNumber from "@/components/form/InputNumber.vue";
import { errBatchColumns } from '../goodsTable'
import SpecifyBatch from './SpecifyBatch.vue'
import { OVERWAREHOUSE } from '../constant'

export default  {
  name: 'ErrBatch',
  components: {
    InputNumber,
    SpecifyBatch
  },
  props:{
    isDischarge:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      visible: false,
      deliverWarehouseCode: '',
      tableList: [],
      errList: [],
      errBatchColumns,
    }
  },
  computed:{
    tableColumns(){
      if(this.isDischarge){
        return errBatchColumns
      }
        return errBatchColumns.filter(item=>item.key!=='stationFullAddress')
    }
  },
  methods: {
    show(list, code) {
      this.deliverWarehouseCode = code
      this.visible = true
      const errList = []
      const tableList = []
      list.forEach(item => {
        const unit = []
        if(item.defaultUnit){
          unit.push({
            value: item.defaultUnit,
          })
        } 
        if (item.bigUnit && unit.filter(n => n.value === item.bigUnit).length <= 0) {
          unit.push({
            value: item.bigUnit,
          })
        }
        if(item.smallUnit && unit.filter((n)=>n.value === item.smallUnit).length <= 0){
          unit.push({
            value: item.smallUnit,
          })
        }
        const params = {
          ...item,
          unit,
          isOverWarehouse: item.isOverWarehouse ? OVERWAREHOUSE[1].value : OVERWAREHOUSE[0].value,
        }
        if (item.invalidStock) {
          errList.push(params)
        } else {
          tableList.push(params)
        }
      });
      this.errList = errList
      this.tableList = tableList
    },
    handleCancel() {
      this.visible = false
    },
    specifyBatch(index, row) {
      this.$refs.specifyBatch.show(index, row, this.deliverWarehouseCode)
    },
    onGoodsDelete(index) {
      this.errList.splice(index, 1);
    },
    chooseBatch(list, skuCode, chooseIndex) {
      const current = this.errList[chooseIndex]
      this.errList.splice(chooseIndex, 1)
      list.forEach(item => {
        let i = -1;
        this.errList.filter((goodItem, index) => {
          if (goodItem.stockBatch === item.batchNo && goodItem.skuCode === skuCode) {
            i = index
          }
          return goodItem
        })
        if (i === -1) {
          this.errList.splice(chooseIndex, 0, {
            ...current,
            stockBatch: item.batchNo,
            availableAmount: item.availableAmount,
            bigUnitAvailableNum: item.bigUnitAvailableNum,
            smallUnitAvailableNum: item.smallUnitAvailableNum,
            conversionRate: item.conversionRate,
          })
        }
      })
    },
    changePrice(value, index) {
      this.errList[index].weight = (value * this.errList[index].weight).toFixed(3);
      this.errList[index].volume = (value * this.errList[index].volume).toFixed(3);
    },
    handleOk() {
      const list = this.errList.concat(this.tableList)
      list.map(item => {
        const current = item
        let conversionRate = 1
        if (current.skuUnit === current.smallUnit) {
          conversionRate = (current.conversionRate || 1) * 1
        }
        const number = current.number * 1
        current.weight = (number * (current.singleWeight || 0) / conversionRate).toFixed(3)
        current.volume = (number * (current.singleVolume || 0) / conversionRate).toFixed(3)
        return current
      })
      if(this.isDischarge){
         this.$emit('changeDischargeGoods', list)
      }else{
        this.$emit('changeGoods', list)
      }
      this.handleCancel()
    },
    handleAvailable() {
      this.errList.map(errItem => {
        const item = errItem
        if(item.skuUnit === item.smallUnit) {
          const numbet = (item.smallUnitAvailableNum || 0) + (item.bigUnitAvailableNum || 0) * (item.conversionRate || 1)
          item.number = numbet
        } else if (item.skuUnit === item.bigUnit) {
          item.number = item.bigUnitAvailableNum || 0
        } else {
          item.number = 1
        }
        return item
      })
    },
  }
}
</script>

<style lang="less" scoped>
.err-batch {
  .batch-title {
    color: #646566;
    font-weight: 400;
    span {
      color: #323232;
      font-weight: 500;
      font-size: 18px;
      margin-right: 8px;
    }
  }
  ::v-deep .ant-modal-body {
    padding: 0;
    .ant-alert-banner {
      background: #FFEFDE;
      .ant-alert-message {
        color: #FB9432;
      }
    }
  }
  .goods-table {
    padding: 24px;
    /deep/ .ant-form-item {
      margin-bottom: 0 !important;
    }
    .titleStyle {
      color: red;
    }
    .deleteBtn {
      color: #06b880;
      font-size: 14px;
      margin-right: 15px;
      &:hover {
        cursor: pointer;
      }
    }
  }
}
.lengthHidden{
  overflow:hidden; 
  text-overflow:ellipsis;
  white-space:nowrap; 
}
</style>
